/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { settings, NuevosClientesControllerApi, FileUploadControllerApi, NavisionControllerApi, CompaniesControllerApi } from '@api/backend'
import { displayErrorMsg, displaySuccessMsg, odataLogs } from '@utils'
import Swal from "sweetalert2"

const prefix = 'nuevosclientes'

export const GET_NUEVO_CLIENTE = `${prefix}/GET_DATA_nuevocliente`
export const GET_NUEVOS_CLIENTES = `${prefix}/GET_DATA`
export const GET_NUEVOS_CLIENTES_ALL = `${prefix}/GET_DATA_ALL`
export const GET_NUEVOS_CLIENTES_COUNT = `${prefix}/GET_DATA_COUNT`
export const ADD_NUEVO_CLIENTE = `${prefix}/ADD`
export const DELETE_NUEVO_CLIENTE = `${prefix}/DELETE`
export const UPDATE_NUEVO_CLIENTE = `${prefix}/UPDATE`
export const GET_FILTROS_NUEVO_CLIENTE = `${prefix}/GET_FILTROS_NUEVO_CLIENTE`
export const INIT_DATA_NECESARIA = `${prefix}/INIT_DATA_NECESARIA`

const apiNavisionNew = new NavisionControllerApi(settings)
const apiNuevosClientes = new NuevosClientesControllerApi(settings)
const apiFileUpload = new FileUploadControllerApi(settings)
const apiEmpresas = new CompaniesControllerApi(settings)

export const getNuevosClientes = params => {
    return async (dispatch, getState) => {
        try {
            const { page = 1, perPage = 10, filtrosBusqueda } = params
            const { nombreCliente, finalizado = 'no_finalizado' } = filtrosBusqueda || {}

            const filter = {
                offset: (page - 1) * perPage,
                limit: perPage,
                skip: ((page - 1) * perPage),
                where: {
                    and: []
                }
            }

            // Obtener datos del usuario en sesión
            const dataUserEnSesion = JSON.parse(localStorage.getItem('userData'))
            const tipoUsuario = dataUserEnSesion?.tipoUsuario
            const rolNombre = dataUserEnSesion?.roles?.name
            const codVendedor = dataUserEnSesion?.codVendedorCliente

            // Siempre incluimos estos filtros ya que tienen valores por defecto
            filter.where.and.push({ 
                nombreCliente: { like: nombreCliente ? `%${nombreCliente}%` : '%%' } 
            })

            // Filtro por estado de finalización
            if (finalizado === 'finalizado') {
                // Solo los que ya tienen fechaFinalizacion != null
                filter.where.and.push({
                    fechaFinalizacion: { neq: null }
                })
            } else if (finalizado === 'no_finalizado') {
                // Solo los que tienen fechaFinalizacion === null
                filter.where.and.push({
                    fechaFinalizacion: { eq: null }
                })
            }

            // Si es VENDEDOR, filtramos los registros por su código de vendedor
            if (tipoUsuario === 'V' && rolNombre === 'Vendedor' && codVendedor) {
                filter.where.and.push({ codigoVendedor: codVendedor })
            }

            const { data: dataNuevosClientes } = await apiNuevosClientes.nuevosClientesControllerFind(JSON.stringify(filter))
            const { data: dataNuevosClientesCount } = await apiNuevosClientes.nuevosClientesControllerCount(JSON.stringify(filter.where))

            dispatch({
                type: GET_NUEVOS_CLIENTES,
                nuevosclientes: dataNuevosClientes,
                total: dataNuevosClientesCount.count || 0,
                params
            })

            //Guardamos los filtros de busqueda (Inputs)
            dispatch({
                type: GET_FILTROS_NUEVO_CLIENTE,
                filtros: filtrosBusqueda
            })
        } catch (err) {
            console.error(err.message)
        }
    }
}

export const addNuevoCliente = (nuevoCliente, intl) => {
    return async (dispatch) => {
        try {
            const { data } = await apiNuevosClientes.nuevosClientesControllerCreate(nuevoCliente)
            console.log('data', data)
            displaySuccessMsg(intl.formatMessage({ id: 'Cliente creado correctamente!!' }))
            dispatch({
                type: ADD_NUEVO_CLIENTE,
                data
            })
            return data
        } catch (err) {
            console.error(err.message)
            console.log(err.message)
        }
    }
}

export const updateNuevoCliente = (id, nuevoCliente, intl) => {
    return async (dispatch) => {
        try {
            const { data } = await apiNuevosClientes.nuevosClientesControllerUpdateById(id, nuevoCliente)
            console.log('data', data)
            displaySuccessMsg(intl.formatMessage({ id: 'Cliente actualizado correctamente!!' }))
            dispatch({
                type: UPDATE_NUEVO_CLIENTE,
                data
            })
            return data
        } catch (err) {
            console.error(err.message)
        }
    }
}

export const deleteNuevoCliente = (nuevoClienteId, intl) => {
    return async (dispatch) => {
        try {
            await apiNuevosClientes.nuevosClientesControllerDeleteById(nuevoClienteId)
            console.log('cliente eliminado', nuevoClienteId)
            displaySuccessMsg(intl.formatMessage({ id: 'Cliente eliminado correctamente!!' }))
            dispatch({
                type: DELETE_NUEVO_CLIENTE,
                data: nuevoClienteId
            })
        } catch (err) {
            console.error(err.message)
        }
    }
}

export const getNuevoCliente = (nuevoCliente) => {
    return async (dispatch) => {
        try {
            const { data: dataNuevoCliente } = await apiNuevosClientes.nuevosClientesControllerFindById(nuevoCliente)
            dispatch({
                type: GET_NUEVO_CLIENTE,
                selectedNuevoCliente: dataNuevoCliente,
                ultimoIdNuevoCliente: nuevoCliente
            })
        } catch (err) {
            console.error(err.message)
        }
    }
}

export const initNuevoCliente = () => {
    return async (dispatch) => {
        dispatch({
            type: GET_NUEVO_CLIENTE,
            selectedNuevoCliente: null
        })
    }
}

export const subirDocumento = (clienteId, tipoDocumento, archivo) => {
    return async () => {
        try {
            const res = await apiFileUpload.fileUploadControllerUploadDocumentoCliente(clienteId, tipoDocumento, archivo)

            const rutaRelativa = res.data?.path
            //const rutaRelativa = rutaCompleta?.replace(/^\.?\/?public\/?/, '')
            return rutaRelativa
        } catch (err) {
            console.error('Error al subir el documento:', err)
            throw err
        }
    }
}

export const notificarPorCorreo = (clienteId, tipoDeFase, email, faseSiguiente = true, clienteEmail, paisFiscal) => {
    return async () => {
        try {
            const url = `nuevosClientes/edit/${clienteId}`
            const objetoParElMail = {
                url,
                fase: tipoDeFase,
                devolverA: faseSiguiente ? '' : email,
                clienteEmail: clienteEmail || '',
                paisFiscal
            }
            const res = await apiNuevosClientes.nuevosClientesControllerNotificarAltaCliente(objetoParElMail)

            console.log('Respuesta email enviado: ', res)
            return 'ok'
        } catch (err) {
            console.error('Error al enviar el email de notificación:', err)
            throw err
        }
    }
}

export const obtenerFormasDePagoBC = () => {
    return async () => {
        try {
            const filtro = `useInB2B eq true`

            // Llamamos al endpoint de formas de pago con el filtro B2B
            const response = await apiNavisionNew.navisionControllerGetendPoint('paymentMethod', filtro, 100000, 0, undefined, undefined, true)

            const { data } = response

            if (data.value.length > 0) {
                return data.value
            } else {
                console.log('No se encontraron formas de pago B2B en BC')
                return []
            }
        } catch (error) {
            console.error('Error al obtener formas de pago B2B:', error)
            return []
        }
    }
}

export const obtenerTerminosDePagoBC = () => {
    return async () => {
        try {
            const filtro = `useInB2B eq true`

            // Llamamos al endpoint de terminos de pago con el filtro B2B
            const response = await apiNavisionNew.navisionControllerGetendPoint('paymentTerms', filtro, 100000, 0, undefined, undefined, true)

            const { data } = response

            if (data.value.length > 0) {
                return data.value
            } else {
                console.log('No se encontraron terminos de pago B2B en BC')
                return []
            }
        } catch (error) {
            console.error('Error al obtener terminos de pago B2B:', error)
            return []
        }
    }
}

export const obtenerTarifasBC = () => {
    return async () => {
        try {
            const filtro = `status eq 'Active'`

            // Llamamos al endpoint de tarifas filtrando solo por las activas
            const response = await apiNavisionNew.navisionControllerGetendPoint('salesPrice', filtro, 100000, 0, undefined, undefined, true)

            const { data } = response

            if (data.value.length > 0) {
                return data.value
            } else {
                console.log('No se encontraron tarifas activas en BC')
                return []
            }
        } catch (error) {
            console.error('Error al obtener tarifas activas en BC:', error)
            return []
        }
    }
}

export const obtenerTipos_carga_descarga_envio_BC = (tipo) => {
    return async () => {
        try {
            const filtro = `type eq '${tipo}'`

            // Llamamos al endpoint de tipos de carga, descarga y envio filtrando por el tipo
            const response = await apiNavisionNew.navisionControllerGetendPoint('salesSupportCode', filtro, 100000, 0, undefined, undefined, true)

            const { data } = response

            if (data.value.length > 0) {
                return data.value
            } else {
                console.log('No se encontraron tipos de carga, descarga o envio en BC')
                return []
            }
        } catch (error) {
            console.error('Error al obtener tipos de carga, descarga o envio en BC:', error)
            return []
        }
    }
}

export const obtenerTodasLasEmpresas = () => {
    return async (dispatch) => {
        try {
            const { data } = await apiEmpresas.companiesControllerFind()
            return data
        } catch (error) {
            console.error('Error al obtener todas las empresas:', error)
            return []
        }
    }
}

export const darDeAltaClienteEnBC = (clienteId, esUsuarioMultiempresa, intl) => {
    return async (dispatch) => {
        try {
            // Mostrar ventana de carga
            Swal.fire({
                icon: "info",
                title: intl.formatMessage({ id: "Espere un momento..." }),
                text: intl.formatMessage({ id: "Dando de alta al cliente en Business Central" }),
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    Swal.showLoading()
                }
            })
            const { data: dataNuevoCliente } = await apiNuevosClientes.nuevosClientesControllerFindById(clienteId)
            const { data: { documentos = [] } } = await apiNuevosClientes.nuevosClientesControllerObtenerDocumentosEnBase64(clienteId)

            // Convertir lista de documentos a mapa por empresa + tipo
            const documentosMap = {}
            documentos.forEach(doc => {
                if (!documentosMap[doc.empresa]) documentosMap[doc.empresa] = {}
                documentosMap[doc.empresa][doc.tipo] = doc.file
            })

            const empresas = [
                {
                    Empresa: "SVAN",
                    Marcas: dataNuevoCliente.marcasSvan?.replace(/,/g, '|') || '',
                    Tarifa: dataNuevoCliente.tarifaSvan || '',
                    Credito: dataNuevoCliente.creditoDelClienteSvan,
                    fileSEPA: documentosMap['SVAN']?.SEPA || '',
                    fileLOPD: documentosMap['SVAN']?.LOPD || ''
                },
                {
                    Empresa: "KOREA",
                    Marcas: dataNuevoCliente.marcasKorean?.replace(/,/g, '|') || '',
                    Tarifa: dataNuevoCliente.tarifaKorean || '',
                    Credito: dataNuevoCliente.creditoDelClienteKorean,
                    fileSEPA: documentosMap['KOREAN']?.SEPA || '',
                    fileLOPD: documentosMap['KOREAN']?.LOPD || ''
                },
                {
                    Empresa: "SOLAR",
                    Marcas: dataNuevoCliente.marcasSolar?.replace(/,/g, '|') || '',
                    Tarifa: dataNuevoCliente.tarifaSolar || '',
                    Credito: dataNuevoCliente.creditoDelClienteSolar,
                    fileSEPA: documentosMap['SOLAR']?.SEPA || '',
                    fileLOPD: documentosMap['SOLAR']?.LOPD || ''
                }
            ]

            const jsonInterno = {
                "Nombre del Cliente": dataNuevoCliente.nombreCliente,
                "CIF/NIF": dataNuevoCliente.cifNif,
                Email: dataNuevoCliente.email,
                "Forma de Pago": dataNuevoCliente.formaDePago,
                "Terminos de Pago": dataNuevoCliente.terminosDePago,
                "Codigo vendedor": dataNuevoCliente.codigoVendedor,
                Teléfono: dataNuevoCliente.telefono,
                "Página Web": dataNuevoCliente.paginaWeb,
                "Direccion Fiscal": {
                    Direccion: dataNuevoCliente.direccionFiscal,
                    "Codigo Postal": dataNuevoCliente.codigoPostalFiscal,
                    Pais: dataNuevoCliente.paisFiscal,
                    Municipio: dataNuevoCliente.municipioFiscal,
                    Provincia: dataNuevoCliente.provinciaFiscal
                },
                "Direccion Entrega": {
                    Direccion: dataNuevoCliente.direccionEntrega,
                    "Codigo Postal": dataNuevoCliente.codigoPostalEntrega,
                    Pais: dataNuevoCliente.paisEntrega,
                    Municipio: dataNuevoCliente.municipioEntrega,
                    Provincia: dataNuevoCliente.provinciaEntrega
                },
                "No dividir": dataNuevoCliente.noDividirOfertaPedido === 'S' ? "true" : "false",
                "Convertir automaticamente": dataNuevoCliente.convertirAutoAPedido === 'S' ? "true" : "false",
                "Mantener Oferta": dataNuevoCliente.mantenerOferta === 'S' ? "true" : "false",
                "Lanzar automaticamente": dataNuevoCliente.lanzarPedidoAuto === 'S' ? "true" : "false",
                "Volumen maximo": dataNuevoCliente.volumenMaxLanzar?.toString() || "0",
                "Dias para cancelar": dataNuevoCliente.diasCancelarPedido?.toString() || "0",
                "Requiere Plataforma": dataNuevoCliente.requierePlataforma === 'S' ? "true" : "false",
                "Tipo carga": dataNuevoCliente.tipoCarga,
                "Tipo envio": dataNuevoCliente.tipoEnvio,
                "Tipo descarga": dataNuevoCliente.tipoDescarga,
                Empresas: empresas
            }

            console.log('jsonInterno Alta cliente:', jsonInterno)

            let payload
            if (esUsuarioMultiempresa) {
                payload = { json: JSON.stringify(jsonInterno), pEmpresa: 'SVAN' }
            } else {
                payload = { json: JSON.stringify(jsonInterno) }
            }

            console.log('JSON Final Alta cliente:', payload)

            const { data } = await apiNavisionNew.navisionControllerPostEndpointBC("TW_Functions_CreateCustomer", payload)

            // Cerrar modal de espera
            Swal.close()

            // Validación adicional por si devuelve status: 'ERROR'
            if (data?.status === 'ERROR') {
                const msg = data?.mensaje?.message || 'Error inesperado al dar de alta el cliente en BC.'
                displayErrorMsg(msg)
                return { success: false }
            }

            let mensaje = data?.mensaje

            if (typeof mensaje === 'string') {
                try {
                    mensaje = JSON.parse(mensaje)
                } catch (e) {
                    displayErrorMsg('Error al interpretar la respuesta del servidor.')
                    return { success: false }
                }
            }

            if (mensaje?.code && mensaje.code !== "0") {
                const errorMsg = (mensaje.message || 'Error al dar de alta el cliente en BC.') + (mensaje.internalError ? ` (${mensaje.internalError})` : '')
                displayErrorMsg(errorMsg)
                return { success: false }
            }

            // Actualizar fase en BD
            await apiNuevosClientes.nuevosClientesControllerUpdateById(clienteId, { fase: 'dadoDeAltaEnBC' })

            if (mensaje?.code === "0" && mensaje.message) {
                displaySuccessMsg(mensaje.message)
            } else {
                displaySuccessMsg(intl.formatMessage({ id: "New client created in BC" }))
            }
            return { success: true }

        } catch (err) {
            displayErrorMsg(err)
            return { success: false }
        }
    }
}
